interface IPolicyMapping {
  base: {
    edit: string
  }
  general: {
    view: string
  }
  organisations: {
    view: string
    edit: string
    admin: string
  }
  flows: {
    view: string
    opsView: string
    edit: string
    admin: string
    salesView: string
  }
  sms_flows: {
    view: string
    edit: string
    admin: string
  }
  e2eTest: {
    admin: string
  }
  calls: {
    agent: {
      custom: string
      view: string
    }
    clientView: string
    admin: string
  }
  campaigns: {
    view: string
    viewBeta: string
    edit: string
    admin: string
    adminBeta: string
  }
  sms_campaigns: {
    view: string
    edit: string
    admin: string
  }
  business_config: {
    view: string
    edit: string
    admin: string
  }
  experiment: {
    admin: string
  }
  experience_center: {
    edit: string
    admin: string
    salesView: string
  }
  number_management: {
    admin: string
    edit: string
  }
  clientSettings: {
    admin: string
    salesView: string
  }
  account_manager: {
    view: string
    edit: string
    admin: string
  }
  media: {
    admin: string
  }
  internal_user: {
    view: string
  }
}

const $PolicyNameMappings: IPolicyMapping = Object.freeze({
  base: {
    edit: 'v2.base.edit',
  },
  general: {
    view: 'v2.general.view',
  },
  organisations: {
    view: 'v2.organisation.view',
    edit: 'v2.organisation.edit',
    admin: 'v2.organisation.admin',
  },
  flows: {
    view: 'v2.flow.view',
    opsView: 'v2.flow_for_ops.custom',
    edit: 'v2.flow.edit',
    admin: 'v2.flow.admin',
    salesView: 'v2.flow_sales_view.custom',
  },
  sms_flows: {
    view: 'v2.sms_flows.view',
    edit: 'v2.sms_flows.edit',
    admin: 'v2.sms_flows.admin',
  },
  e2eTest: {
    admin: 'v2.e2e_test.admin',
  },
  calls: {
    clientView: 'v2.calls_for_clients.custom',
    agent: {
      custom: 'v2.calls_for_agent.custom',
      view: 'v2.calls_for_agent.view',
    },
    admin: 'v2.calls.admin',
  },
  campaigns: {
    view: 'v2.campaigns.view',
    viewBeta: 'v2.campaigns-beta.view',
    edit: 'v2.campaigns.edit',
    admin: 'v2.campaigns.admin',
    adminBeta: 'v2.campaigns-beta.admin',
  },
  sms_campaigns: {
    view: 'v2.sms_campaigns.view',
    edit: 'v2.sms_campaigns.edit',
    admin: 'v2.sms_campaigns.admin',
  },
  business_config: {
    view: 'v2.business_config.view',
    edit: 'v2.business_config.edit',
    admin: 'v2.business_config.admin',
  },
  experiment: {
    admin: 'v2.flow_experiment.admin',
  },
  experience_center: {
    edit: 'v2.experience_center.edit',
    admin: 'v2.experience_center.admin',
    salesView: 'v2.experience_center_sales.custom',
  },
  number_management: {
    admin: 'v2.number_management.admin',
    edit: 'v2.number_management.edit',
  },
  clientSettings: {
    admin: 'v2.client_settings.admin',
    salesView: 'v2.client_settings_sales_view.custom',
  },
  account_manager: {
    view: 'v2.account_manager.view',
    edit: 'v2.account_manager.edit',
    admin: 'v2.account_manager.admin',
  },
  media: {
    admin: 'v2.download_media.admin',
  },
  internal_user: {
    view: 'v2.internal_user.view',
  },
})

const GetPolicyMappings = () => {
  const _policyMappings = {
    // Campaigns Page - Outside Clients
    campaignsRootViewCampaigns: [
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    clientCampaignsView: [
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignsCreateCampaign: [
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignsShowActionsButtons: [
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
      $PolicyNameMappings.campaigns.adminBeta,
    ],
    campaignsUploadExclusionSheet: [
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignsDownloadOriginalFile: [
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignsCancelCampaign: [
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.admin,
      $PolicyNameMappings.campaigns.edit,
    ],
    campaignsStartCampaign: [
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignsDownloadCleansedFile: [
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignsPauseResumePurge: [
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.viewBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    campaignAdjustPace: [
      $PolicyNameMappings.campaigns.adminBeta,
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    smsCampaignsView: [
      $PolicyNameMappings.sms_campaigns.view,
      $PolicyNameMappings.sms_campaigns.edit,
      $PolicyNameMappings.sms_campaigns.admin,
    ],
    smsCampaignsEdit: [
      $PolicyNameMappings.sms_campaigns.edit,
      $PolicyNameMappings.sms_campaigns.admin,
    ],

    // Client Page
    clientsAddNewClientButton: [
      $PolicyNameMappings.organisations.edit,
      $PolicyNameMappings.organisations.admin,
    ],
    clientsViewClients: [
      $PolicyNameMappings.organisations.view,
      $PolicyNameMappings.organisations.edit,
      $PolicyNameMappings.organisations.admin,
    ],
    clientsSearchButton: [$PolicyNameMappings.internal_user.view],

    // Template Page
    templateStorePage: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],
    templateStoreNavigationButton: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    templateStoreViewTemplates: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],
    templateStoreViewTemplateUsageButton: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    templateStoreUpgradeToPublicMenu: [$PolicyNameMappings.flows.admin],
    templateStoreViewUpdateLogMenu: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],

    // Experience Center
    dxcView: [
      $PolicyNameMappings.experience_center.admin,
      $PolicyNameMappings.experience_center.salesView,
      $PolicyNameMappings.experience_center.edit,
    ],
    dxcLandingPage: [$PolicyNameMappings.experience_center.salesView],
    dxcViewInteractiveDemos: [
      $PolicyNameMappings.experience_center.admin,
      $PolicyNameMappings.experience_center.salesView,
      $PolicyNameMappings.experience_center.edit,
    ],
    dxcViewDemoUsers: [
      $PolicyNameMappings.experience_center.admin,
      $PolicyNameMappings.experience_center.edit,
      $PolicyNameMappings.experience_center.salesView,
    ],
    dxcViewDisabledDemos: [$PolicyNameMappings.experience_center.admin],
    dxcEditInteractiveDemoSettings: [
      $PolicyNameMappings.experience_center.admin,
      $PolicyNameMappings.experience_center.edit,
    ],

    // VA list Page
    vaViewVoiceAgents: [
      $PolicyNameMappings.flows.view,
      $PolicyNameMappings.flows.opsView,
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    vaSearchVoiceAgentsButton: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],
    vaAddVoiceAgentsButton: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],
    vaCardManageCampaignButton: [
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    vaCardViewTemplatesUsedButton: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    vaCardViewAnalyticsButton: [
      $PolicyNameMappings.flows.view,
      $PolicyNameMappings.flows.opsView,
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    smsAgentsView: [
      $PolicyNameMappings.sms_flows.view,
      $PolicyNameMappings.sms_flows.edit,
      $PolicyNameMappings.sms_flows.admin,
    ],
    smsAgentsEdit: [$PolicyNameMappings.sms_flows.edit],

    // Clients -> Settings
    viewClientSettings: [
      $PolicyNameMappings.clientSettings.admin,
      $PolicyNameMappings.clientSettings.salesView,
    ],
    viewClientSettingsPaymentPortal: [$PolicyNameMappings.clientSettings.admin],

    // Application Page - Build -> Configure
    appConfigureViewTab: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appConfigureEditConfigurations: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appConfigureViewAccountAttributes: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    // Application Page - Build -> Integrations
    appIntegrationsViewTab: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.opsView,
      $PolicyNameMappings.flows.salesView,
    ],
    appIntegrationsEditTab: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appIntegrationsViewProvider: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appIntegrationsChangeVANumber: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appIntegrationsEditTemplateId: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],

    // Application Page - Build -> Prompts Options
    appPromptOptionsViewTab: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appPromptOptionsViewAllPrompts: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appPromptOptionsEditPrompts: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
      $PolicyNameMappings.flows.salesView,
    ],
    appPromptOptionsPerformUndoRedo: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    appPromptOptionsResetPrompts: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],

    // Application Page - Monitor -> Analytics
    appAnalyticsViewTab: [
      $PolicyNameMappings.flows.view,
      $PolicyNameMappings.flows.opsView,
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    appAnalyticsFilterButton: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],

    // Application Page - Monitor -> Calls
    appCallsViewCalls: [$PolicyNameMappings.calls.clientView, $PolicyNameMappings.calls.admin],
    appCallsDownloadCallAudio: [
      $PolicyNameMappings.calls.clientView,
      $PolicyNameMappings.calls.admin,
    ],
    appCallsViewCallDetails: [
      $PolicyNameMappings.calls.clientView,
      $PolicyNameMappings.calls.admin,
      $PolicyNameMappings.experience_center.salesView,
    ],
    appCallsApplyFilters: [$PolicyNameMappings.calls.clientView, $PolicyNameMappings.calls.admin],
    appCallsShowSSMLTags: [$PolicyNameMappings.calls.admin],
    appCallsViewCallMetadata: [$PolicyNameMappings.calls.admin],
    appCallsViewTurnMetadata: [$PolicyNameMappings.calls.admin],
    appCallsMarkGoldenCall: [$PolicyNameMappings.e2eTest.admin],
    appCallsDeveloperMode: [$PolicyNameMappings.calls.admin],
    appCallsPlayCallAudio: [$PolicyNameMappings.calls.clientView, $PolicyNameMappings.calls.admin],

    // Application Page - Monitor -> Data Export
    appMonitorDataExport: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],

    // Application Page - Test
    appTestViewPipeline: [$PolicyNameMappings.e2eTest.admin],
    appTestRunPipeline: [$PolicyNameMappings.e2eTest.admin],
    appTestViewGoldenCall: [$PolicyNameMappings.e2eTest.admin],

    // Application Page - Control Panel -> Campaigns
    appControlPanelNewCampaignButton: [
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],
    appControlPanelViewCampaigns: [
      $PolicyNameMappings.campaigns.edit,
      $PolicyNameMappings.campaigns.admin,
    ],

    // Application Page - Settings
    appSettingsUpgradeToBetaButton: [$PolicyNameMappings.flows.admin],
    appSettingsModifyVoiceAgent: [$PolicyNameMappings.flows.edit, $PolicyNameMappings.flows.admin],
    appSettingsChangeCollectorType: [
      $PolicyNameMappings.flows.edit,
      $PolicyNameMappings.flows.admin,
    ],
    appSettingsExperimentSettings: [$PolicyNameMappings.experiment.admin],
    appSettingsModifyVoiceAgentStatus: [$PolicyNameMappings.flows.admin],

    // Application Page - Agent
    appSettingsAgentView: [
      $PolicyNameMappings.calls.agent.view,
      $PolicyNameMappings.calls.clientView,
      $PolicyNameMappings.calls.admin,
    ],
    appSettingsAgentSearchOnly: [$PolicyNameMappings.calls.agent.custom],

    // Application Page - Business Configuration
    appBusinessConfigurationView: [$PolicyNameMappings.business_config.view],
    appBusinessConfigurationCreate: [$PolicyNameMappings.business_config.admin],
    appBusinessConfigurationEdit: [$PolicyNameMappings.business_config.edit],

    numberManagementAdmin: [$PolicyNameMappings.number_management.admin],
    numberManagementEdit: [$PolicyNameMappings.number_management.edit],

    // Client archival / unarchival
    clientArchivalUnarchivalAdmin: [$PolicyNameMappings.organisations.admin],

    // Flow archival / unarchival
    flowArchivalUnarchivalAdmin: [$PolicyNameMappings.flows.admin],

    // Account Manager
    accountManagerSettings: [
      $PolicyNameMappings.account_manager.edit,
      $PolicyNameMappings.account_manager.admin,
    ],

    downloadMediaAdmin: [$PolicyNameMappings.media.admin],
    campaignsTestView: [$PolicyNameMappings.campaigns.admin],
  }
  Object.keys(_policyMappings).forEach((pmKey) => {
    _policyMappings[pmKey] = [..._policyMappings[pmKey], 'v2.all.admin']
  })
  return _policyMappings
}

/**
 * A key, value mapping of UI Components to their required auth policies
 */
const PolicyMappings = Object.freeze(GetPolicyMappings())

export default PolicyMappings
